import type { ReactNode } from 'react';

// The site-wide footer (App.tsx / AppFooter, fixed) already sits at the
// bottom on desktop; md:pb-14 keeps the centred card clear of it.
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[var(--color-bg)] px-4 py-10 md:pb-14">
      <div className="w-full max-w-md flex flex-col gap-6">
        <div className="flex flex-col items-center gap-2 mb-2">
          <img src="/zmist-logo.svg" alt="Zmist" className="w-16 h-16" />
          <span className="text-lg font-semibold tracking-wide">Zmist</span>
        </div>
        {children}
      </div>
    </div>
  );
}
